export const QuoteError = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
      fill="#FCD2DE"
    />
    <path
      d="M25.8919 25.89C27.4547 24.3271 28.3327 22.2075 28.3327 19.9974C28.3327 17.7873 27.4547 15.6676 25.8919 14.1048C24.3291 12.542 22.2095 11.6641 19.9993 11.6641C17.7892 11.6641 15.6696 12.542 14.1068 14.1048M25.8919 25.89C24.3291 27.4528 22.2095 28.3307 19.9993 28.3307C17.7892 28.3307 15.6696 27.4528 14.1068 25.89C12.544 24.3271 11.666 22.2075 11.666 19.9974C11.666 17.7873 12.544 15.6676 14.1068 14.1048M25.8919 25.89L14.1068 14.1048"
      stroke="#222222"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)